<template>
<div class="lately">
    <div class="lately_top">
        <div class="lately_go_back"></div>
        <div class="lately_title">系统检测到您浏览过【淘宝网】</div>
    </div>
    <div class="lately_record">
        <div class="record_exp">
            若您已下单，点击下面按钮<span class="record_order">【记录订单】</span>，订单会在“最近订单“里出现，去淘宝<span class="record_true">【确认收货】</span>后，我们会发放到您的寻匠之美账户中。  
            <div class="record_button">记录订单</div>
        </div>
        
    </div>
</div>
</template>
<script>
    export default {
        name: 'Lately',
        data () {
             return {

             }
        },
    }
</script>
<style scoped>
.lately_top{width:100%;height:140px;background:#F8F8F8;line-height:100px;font-size:28px;color:#4A4A4A;display: flex;justify-content: flex-start;}
.lately_go_back{width:48px;height:48px;background:url(/static/images/team_go_back.png) no-repeat center center;background-size:100% 100%;margin:26px 20px 0 20px;}
.lately_record{width:100%;border-radius:40px 40px 0 0;background:#FFF;position: relative;top:-40px;padding-top:46px;}
.record_exp{font-size:28px;color:#000000;width:674px;margin:0 auto;line-height:60px;}
.record_exp .record_order{color: #4A90E2;}
.record_exp .record_true{color:#FE3B30;}
.record_button{width:240px;height:80px;border-radius:40px;border:2px solid #000000;font-size:32px;color:#000000;line-height:80px;text-align:center;margin-top:74px;margin-left:auto;}
</style>



// WEBPACK FOOTER //
// src/components/person/lately.vue